var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVantageText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 26,
    viewBox: "0 0 288 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.710938 0.603027H2.74216L10.8356 22.6945L18.9604 0.603027H20.9602L11.8275 25.1037H9.85931L0.710938 0.603027Z",
    fill: "#00004E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5417 18.8839H27.2599L24.8823 25.1193H22.9141L32.4403 0.618652H34.4086L43.8719 25.1193H41.9036L39.5417 18.8839ZM38.8647 17.1361L33.4008 2.88606L27.937 17.1361H38.8647Z",
    fill: "#00004E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7551 0.603027V25.1037H66.1018L51.6471 4.01989V25.1037H49.7891V0.603027H51.3951L65.8971 21.6868V0.603027H67.7551Z",
    fill: "#00004E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2501 2.36645H83.5503V25.1193H81.6608V2.36645H73.9453V0.618652H91.2343V2.36645H91.2501Z",
    fill: "#00004E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.8 18.8839H97.5178L95.1401 25.1193H93.1719L102.698 0.618652H104.666L114.161 25.1193H112.193L109.8 18.8839ZM109.138 17.1361L103.674 2.88606L98.2106 17.1361H109.138Z",
    fill: "#00004E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.502 14.6485C142.502 20.5689 137.983 25.4974 130.661 25.4974C123.056 25.4974 117.781 19.8604 117.781 12.8534C117.781 5.84651 123.072 0.209473 130.52 0.209473C135.07 0.209473 139.022 2.58711 141.054 6.12993L139.4 7.10618C137.794 4.01998 134.362 1.98876 130.504 1.98876C124.064 1.98876 119.608 6.82276 119.608 12.8377C119.608 18.8526 124.048 23.6866 130.63 23.6866C136.582 23.6866 140.188 20.0178 140.566 15.42H130.173V13.6722H142.455V14.6485H142.502Z",
    fill: "#00004E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M163.616 23.3716V25.1194H149.508V0.603027H163.443V2.35082H151.366V11.8771H162.577V13.6249H151.366V23.3716H163.616Z",
    fill: "#00004E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M198.166 8.2083C198.166 12.5069 194.938 15.7663 190.529 15.7663H184.057V25.1194H182.199V0.603027H190.529C194.953 0.603027 198.166 3.86243 198.166 8.2083ZM196.323 8.2083C196.323 4.80718 193.914 2.36657 190.545 2.36657H184.073V14.0185H190.545C193.898 14.0185 196.323 11.5622 196.323 8.2083Z",
    fill: "#00004E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M203.535 12.8691C203.535 5.86213 209.109 0.225098 216.179 0.225098C223.249 0.225098 228.823 5.86213 228.823 12.8691C228.823 19.876 223.249 25.513 216.179 25.513C209.093 25.4973 203.535 19.8602 203.535 12.8691ZM226.949 12.8691C226.949 6.85412 222.226 2.02013 216.163 2.02013C210.101 2.02013 205.377 6.85412 205.377 12.8691C205.377 18.884 210.101 23.718 216.163 23.718C222.226 23.718 226.949 18.884 226.949 12.8691Z",
    fill: "#00004E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M237.702 0.603027V25.1037H235.844V0.603027H237.702Z",
    fill: "#00004E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M264.091 0.603027V25.1037H262.438L247.983 4.01989V25.1037H246.125V0.603027H247.731L262.233 21.6868V0.603027H264.091Z",
    fill: "#00004E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M287.586 2.36645H279.886V25.1193H277.997V2.36645H270.297V0.618652H287.586V2.36645Z",
    fill: "#00004E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVantageText);
export default __webpack_public_path__ + "static/media/vantageText.f8171f07b238e84dc2d0541f0f75cf17.svg";
export { ForwardRef as ReactComponent };